import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/utils/lib";

const badgeVariants = cva(
  `
    block
    items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors
    focus:ring-2
    focus:ring-ring focus:ring-offset-2 focus:outline-hidden
  `,
  {
    variants: {
      variant: {
        default: `
          border-transparent
          bg-primary text-primary-foreground hover:bg-primary/80
        `,
        secondary: `
          border-transparent
          bg-secondary text-muted-foreground hover:bg-secondary/80
        `,
        destructive: `
          border-transparent
          bg-destructive text-background hover:bg-destructive/80
        `,
        outline: "text-muted",
        success: "border-transparent bg-green-600 text-background",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
